import apiClient from "services/ApiClient";
import { API_ROUTES } from "definitions/constants/routeConstants";
import type { JourneyPreviewRequest, JourneyPreviewResponse } from "./types";

/**
 * POST /api/journey-previews — returns a computed preview of what one or
 * more Paths would look like as a new hire journey starting on `startDate`.
 *
 * No DB writes occur server-side; this is a pure projection.
 *
 * The apiClient auto-unwraps the `{ data: ... }` envelope, so the resolved
 * value is the response shape directly.
 */
export async function createJourneyPreview(payload: JourneyPreviewRequest): Promise<JourneyPreviewResponse> {
  return apiClient.post<JourneyPreviewResponse>(API_ROUTES.journeyPreviews.base, payload);
}
